import React from "react";
import StreamContainerFetcher from "./components/StreamContainerFetcher";

const App: React.FC = () => {
  return (
    <div className="App">
      <StreamContainerFetcher />
    </div>
  );
};

export default App;
